import React from "react";
import ReportStatusDashboard from "./ReportStatusDashboard";
import "./dashboard.css";
import MomStatusDashboard from "./MomStatusDashboard";
import { IAdmin, IDataCenter } from "../../vm";
import { getAllDataCenters } from "../../services/datacenter/DatacenterService";
import ManualReadingDashboard from "./ManualReadingDashboard";
import SlaMatrixDashboard from "./SlaMatrixDashboard";
import SensorReadingDashboard from "./SensorReadingDashboard";
import { parseJwt } from "../../services/UtilService";
import MomStatusGraph from "./MomStatusGraph";
import { getAllAdmins } from "../../services/datacenter/DataCenterManagerService";
import { IDropdownOption } from "office-ui-fabric-react";

export interface DashboardMainProps { }

const DashboardMain: React.FC<DashboardMainProps> = () => {
  // custom hooks'
  // const token: IStackTokens = { childrenGap: 32 };

  const tokenData = parseJwt();

  // state
  const [state, setState] = React.useState({
    isLoading: false,
    datacenters: [],
    cemUsers: []
  } as {
    isLoading: boolean;
    datacenters: IDataCenter[];
    cemUsers: IDropdownOption[];
  });

  // hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
      await getDatacenters();
    };
    asyncFunc();
  }, []);

  const getDatacenters = async () => {
    setState({ ...state, isLoading: true });
    let result = await getAllDataCenters();
    if (result?.success) {
      let obj = {
        ...state,
        datacenters: result.data || [],
      };
      await getAllCemUsers(obj);
      // setState({
      //   ...state,
      //   datacenters: result.data || [],
      //   // isLoading: false,
      // });
    } else {
      setState({ ...state, isLoading: false });
      // showToast(result?.message || "Error while getting datacenters", "error");
    }
  };

  const getAllCemUsers = async (paramState: typeof state) => {
    let result = await getAllAdmins({ role: 2, sendEnabledItems: true });
    if (result && result?.success) {
      let list = result.data.map((d: IAdmin) => ({ key: d._id, text: d.name }));
      setState({
        ...paramState,
        cemUsers: list,
        isLoading: false
      });
    } else {
      setState({ ...paramState, isLoading: false });
      // showToast(result?.message || "Error while getting Cem users", "error");
    }
  };

  return (
    <React.Fragment>
      {state.datacenters.length > 0 && (
        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6">
              <ReportStatusDashboard datacenters={state.datacenters} cemUsers={state.cemUsers} />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6">
              <MomStatusDashboard cemUsers={state.cemUsers} />
            </div>
            {tokenData.isAdmin && [0, 2, 4, 5].includes(tokenData.role) && (
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 pt-16">
                <MomStatusGraph />
              </div>
            )}
            {![2, 5].includes(tokenData.role) && (
              <>
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 pt-16">
                  <ManualReadingDashboard datacenters={state.datacenters} />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 pt-16">
                  <SlaMatrixDashboard datacenters={state.datacenters} />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 pt-16">
                  <SensorReadingDashboard datacenters={state.datacenters} />
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default DashboardMain;
